import BaseTable from 'packages/tables/BaseTable';
import {STANDING_HEADERS} from 'packages/constants/table-constants';
import {useQuery} from '@apollo/client';
// import Button from '@material-ui/core/Button';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow/TableRow';
import {GET_STANDING} from 'packages/graphql/v2/queries';
import Skeleton from '@material-ui/lab/Skeleton';
import {Competitor} from 'packages/common-types/schema-types';
// import StyledButton from 'packages/common-ui/StyledButton';
import useTablePagination from 'packages/hooks/use-table-pagination';
import EmptyComponent from 'packages/common-ui/EmptyComponent';
import {calculateDiffEffectiveness} from './helpers';

// Fixme: REMOVE OR REVIEW
// Why?: Take a look at the method `calculateDiffEffectiveness`. We are doing all the sorting stuff right there.
// eslint-disable-next-line no-unused-vars
const sortByMatchDifference = (
  opponentA: Competitor,
  opponentB: Competitor
) => {
  if (opponentA.matchDifference < opponentB.matchDifference) {
    return 1;
  }
  if (opponentA.matchDifference > opponentB.matchDifference) {
    return -1;
  }
  if (opponentA.pointDifference < opponentB.pointDifference) {
    return 1;
  }
  if (opponentA.pointDifference > opponentB.pointDifference) {
    return -1;
  }
  if (opponentA.pointsInFavor < opponentB.pointsInFavor) {
    return 1;
  }
  if (opponentA.pointsInFavor > opponentB.pointsInFavor) {
    return -1;
  }
  return 0;
};

type GetStandingsVars = {
  tournamentId: string;
};
type GetStandingsData = {
  getStanding: {
    idTournament: string;
    table: Competitor[];
  };
};

type Props = {
  idTournament: string;
};

const LeaderBoard = (props: Props) => {
  const {idTournament} = props;
  const {data, loading} = useQuery<GetStandingsData, GetStandingsVars>(
    GET_STANDING,
    {
      variables: {
        tournamentId: idTournament,
      },
      fetchPolicy: 'network-only',
    }
  );

  const {onChangePage, onChangeRowsPerPage, page, rowsPerPage} =
    useTablePagination();

  if (!data && !loading) {
    return <EmptyComponent message="No hay estadísticas para este torneo" />;
  }

  if (loading) {
    return (
      <>
        <div style={{marginTop: 30}}>
          <Skeleton variant="rect" height={38} />
          <Skeleton variant="rect" height={38} />
          <Skeleton variant="rect" height={38} />
          <Skeleton variant="rect" height={38} />
          <Skeleton variant="rect" height={38} />
        </div>
      </>
    );
  }

  const renderTableData = () => {
    const standings = data?.getStanding.table || [];
    const standingsWithDiffEff =
      standings && calculateDiffEffectiveness(standings);

    return [...standingsWithDiffEff]
      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      .map((standing) => {
        const {
          place,
          groupNumber,
          members,
          gamesPlayed,
          matchesWon,
          matchesLose,
          matchDifference,
          pointsInFavor,
          pointsAgainst,
          pointDifference,
          diffEffect,
        } = standing;
        const fullName = members.map((member) => member.fullName).join(',');
        return (
          <TableRow key={groupNumber}>
            <TableCell component="th" scope="row">
              {place + 1}
            </TableCell>
            <TableCell align="right">{groupNumber + 1}</TableCell>
            <TableCell align="right">{fullName}</TableCell>
            <TableCell align="right">{gamesPlayed}</TableCell>
            <TableCell align="right">{matchesWon}</TableCell>
            <TableCell align="right">{matchesLose}</TableCell>
            <TableCell align="right">{matchDifference}</TableCell>
            <TableCell align="right">{pointDifference}</TableCell>
            <TableCell align="right">{pointsInFavor}</TableCell>
            <TableCell align="right">{pointsAgainst}</TableCell>
            <TableCell align="right">{diffEffect}</TableCell>
          </TableRow>
        );
      });
  };

  return (
    <>
      <BaseTable headers={STANDING_HEADERS}>{renderTableData()}</BaseTable>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        component="div"
        count={data?.getStanding?.table.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onChangeRowsPerPage={onChangeRowsPerPage}
      />
    </>
  );
};

export default LeaderBoard;
